import "../../stylesheets/about-package/about.less";
import "../../stylesheets/shared-package/shared.less";

import {t} from "@lingui/core/macro";
import classNames from "classnames";
import * as React from "react";
import {Link} from "react-router-dom";

type Props = {
    aboutSelection?: string;
};

type State = {
    expanded: boolean;
};

export default class AboutNav extends React.Component<Props, State> {
    state: State = {
        expanded: true,
    };

    handleHamburgerClick: (event: React.MouseEvent) => void = (
        event: React.MouseEvent,
    ) => {
        event.preventDefault();
        this.setState({expanded: !this.state.expanded});
    };

    isSelected: (selection: string) => string = (selection: string) =>
        selection === this.props.aboutSelection ? "selected" : "";

    render(): React.ReactNode {
        const aboutNavOptions = [
            {
                to: "/about",
                selectionId: "about",
                text: t`About`,
            },
            {
                to: "https://blog.khanacademy.org/research/",
                selectionId: "impact",
                text: t`Impact`,
                isExternal: true,
            },
            {
                to: "/about/the-team",
                selectionId: "the-team",
                text: t`Team`,
            },
            {
                to: "/about/our-interns",
                selectionId: "our-interns",

                text: t`Interns`,
            },
            {
                to: "/about/our-content-specialists",
                selectionId: "our-content-specialists",

                text: t`Content Specialists`,
            },
            {
                to: "/about/our-board",
                selectionId: "our-board",

                text: t`Leadership`,
            },
            {
                to: "/about/our-supporters",
                selectionId: "our-supporters",

                text: t`Supporters`,
            },
            {
                to: "/contribute",
                selectionId: "contribute",

                text: t`Translators`,
            },
            {
                to: "https://blog.khanacademy.org/news/",
                selectionId: "blog",
                isExternal: true,
                text: t`Blog`,
            },
        ];

        return (
            <nav className="about-nav" style={{position: "sticky", top: 0}}>
                <a
                    href="/"
                    className="about-nav-hamburger"
                    onClick={this.handleHamburgerClick}
                >
                    <i className="icon-reorder" />
                </a>
                <ul
                    className={classNames({
                        "about-nav-options": true,
                        "about-nav-expanded": this.state.expanded,
                    })}
                >
                    {aboutNavOptions.map((option, i) => {
                        if (option.isExternal) {
                            return (
                                <li key={i}>
                                    <a href={option.to} target="_blank">
                                        {option.text}
                                    </a>
                                </li>
                            );
                        }

                        return (
                            <li key={i}>
                                <Link
                                    to={option.to}
                                    className={this.isSelected(
                                        option.selectionId,
                                    )}
                                >
                                    {option.text}
                                </Link>
                            </li>
                        );
                    })}
                </ul>
            </nav>
        );
    }
}
